const sendEvent = <T extends string>(event: T, data: unknown): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, data });
};

export default { sendEvent };
